import { render, staticRenderFns } from "./RootChrome.vue?vue&type=template&id=6ee19b20&scoped=true"
import script from "./RootChrome.vue?vue&type=script&lang=js"
export * from "./RootChrome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee19b20",
  null
  
)

export default component.exports